import { CanActivateFn, Router } from "@angular/router";
import { inject } from "@angular/core";
import { AuthService } from "./auth.service";
import { of } from "rxjs";
import { catchError, first, map, switchMap } from "rxjs/operators";

export const notLoggedInGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const openPaths = [
    "confirm-email-change","confirm-email"
  ];
  if (openPaths.some((p) => state.url.includes(p))) {
    return true;
  }

  // if already have a token, bounce to home
  if (auth.accessToken) return router.createUrlTree(["/"]);

  // Try silent refresh; if it succeeds, skip the login page
  return auth.init().pipe(
    first(),
    switchMap(() => {
      if (auth.accessToken) {
        return of(router.createUrlTree(["/"]));
      }
      return of(true);
    }),
    catchError(() => of(true)),
  );
};
